// extracted by mini-css-extract-plugin
export default {"mainContainer":"GroupNameEditor_mainContainer__QUU5g","autocomplete":"GroupNameEditor_autocomplete__MhGZK"};